module.exports = __webpack_public_path__ + "static/media/Montes del plata.811e892d.jpeg";